<section class="container-fluid">
  <aside class="card">
  <div class="row">
    <div class="col-12 padding-margin-zero">
      <div class="header-card card-body">
        <div class="center-div">Sorry, this page isn't available: 404</div>
        <!-- <div class="bottom-link"><span><a href="/contact" class="btn">Contact NYCHA</a><a href="/" class="btn gap">Go Home</a></span></div> -->
      </div>
      <footer class="card-footer d-grid">
        <div class="bottom-link"><span><a href="/contact" class="btn">Contact NYCHA</a><a href="/" class="btn gap">Go Home</a></span></div>
      </footer>
      
    </div>
  </div>
</aside>
</section>
